import React from 'react'
import styled from 'styled-components'

// Components
import { Button } from '../../../_components/Button'

// Utils
import { formatCurrency } from '../../../_helpers/formatting'

export const S_ConfirmModal = styled.div`
  p {
    margin: 20px 0;
  }

  .actions-row {
    margin-top: 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
`

export const ConfirmModal = (props) => {
  const { confirmApproveFR, cancelApproveFR, proposeObj, businessName } = props

  let message = ''

  if (proposeObj) {
    // This is what comes back from the /propose endpoint for BBC.
    // Does not apply to factoring.
    const summary = proposeObj.summaries[0]

    // Get the positive amount to be transfered
    const totalValue = Object.values(summary)[1]

    message = `This approval will increase the credit for ${businessName} by ${formatCurrency(totalValue)}.`
  } else {
    // This would be factoring. Unsure if skipping the propose step is the right way
    // but the backend currently only supports approving FR for factoring this way.
    message = `This will approve the funding request for ${businessName}.`
  }

  return (
    <S_ConfirmModal>
      <h2>Confirm Approval</h2>
      <p>{message}</p>
      <div className="actions-row">
        <Button onClick={cancelApproveFR} text="Cancel" />
        <Button onClick={confirmApproveFR} text="Confirm" />
      </div>
    </S_ConfirmModal>
  )
}
